const wrapRequest = (requestBodyDto) => ({
  version: "1.0.0",
  requestBodyDto,
})

const unwrapEntity = (data, fallback = "Request failed") => {
  const ok = data?.responseCode === "OC_OK" || data?.code === "OC_OK"
  if (ok) {
    return data.responseEntity ?? data.createdEntity
  }
  const parts = formatErrorParts(data?.errors)
  const message = parts
    ? data?.message && data.message !== parts
      ? `${data.message}: ${parts}`
      : parts
    : data?.message || fallback
  throw new Error(message)
}

const formatErrorParts = (errors) => {
  if (!Array.isArray(errors) || !errors.length) return ""
  return errors
    .map((item) => {
      if (typeof item === "string") return item
      if (item && typeof item === "object") {
        return item.errorMsg || item.message || ""
      }
      return ""
    })
    .filter(Boolean)
    .join("; ")
}

const getEnvelopeError = (error) => {
  if (error?.response?.data) {
    const data = error.response.data
    const parts = formatErrorParts(data.errors)
    const message = parts ? (data.message ? `${data.message}: ${parts}` : parts) : data.message || "Unknown error"
    return {
      ...data,
      message,
      code: data.code || data.responseCode,
      status: error.response.status,
    }
  }
  if (error?.message) {
    return { message: error.message, status: error.status || error.response?.status }
  }
  return { message: "Unknown error", status: error?.response?.status }
}

const isInviteMissingStatus = (status) => [401, 403, 404, 406].includes(Number(status))

export { wrapRequest, unwrapEntity, getEnvelopeError, isInviteMissingStatus }
